@if (isInTab === false) {
  <h1 class="title-center">Client Contracts</h1>
} @else {
  <h4 class="title-center">Client Contracts</h4>
}

<br />

<br>
  <br>

  <app-lt-png-table #clientContractGrid [gridSettingsInput]="clientContractGridSettings()" [showToolbarInput]="false" ></app-lt-png-table>
